import { render, staticRenderFns } from "./QrPaymentRequest.vue?vue&type=template&id=35670247"
import script from "./QrPaymentRequest.vue?vue&type=script&lang=js"
export * from "./QrPaymentRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports